/**
 * Provides Event handling functionality
 */
export default {
  props: {
    customEvents: {
      type: Array,
      default: () => [
        {
          emit: 'elementClick',
          event: 'click',
          query: '',
          // eslint-disable-next-line no-unused-vars
          cb: element => {},
        },
      ],
    },
  },
  data: () => ({
    registeredEvents: [],
  }),
  methods: {
    onElementClick(data, eventType = 'elementClick') {
      this.$emit(eventType, data)
    },
    eventHandler(element, cb, emit = 'elementClick') {
      return () => {
        try {
          const data = cb(element)
          this.onElementClick(data, emit)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error)
        }
      }
    },
    registerCustomEvents() {
      if (!this.customEvents || !this.customEvents.length) {
        return
      }
      this.registeredEvents = []

      this.customEvents.forEach(({ emit, event = 'click', query, cb }) => {
        if (query && cb && typeof cb === 'function') {
          const elements = document.querySelectorAll(query)
          elements.forEach(element =>
            element.addEventListener(
              event,
              this.eventHandler(element, cb, emit)
            )
          )
          // add the registered elements and their event
          this.registeredEvents.push({ elements, event })
        }
      })
    },
    clearCustomEvents() {
      if (!this.registeredEvents || !this.registeredEvents.length) {
        return
      }

      this.registeredEvents.forEach(({ elements, event }) =>
        elements.forEach(element =>
          element.removeEventListener(event, this.eventHandler)
        )
      )
    },
  },
  mounted() {
    this.registerCustomEvents()
  },
  beforeDestroy() {
    this.clearCustomEvents()
  },
}
